import { AppBar, Avatar, MuiThemeProvider, Toolbar } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import ReportBug from 'app/Core/Components/ReportBug/ReportBug';
import LockPage from 'app/Core/Components/ScreenLock/LockPage';
import UpdateVersion from 'app/Core/Components/UpdateVersion/UpdateVersion';
import ViewUID from 'app/Core/Components/ViewUID/ViewUID';
import TermoUso from 'app/Core/Funcionalidade/TermoUso/TermoUso';
import * as Helpers from 'app/Core/Helpers';
import history from 'history.js';
import React from 'react';
import connect from 'react-redux/es/connect/connect';
import * as serviceWorker from 'serviceWorker';

const FooterLayout1 = ({ xappRouteParams, footerTheme, settings }) => {

    return (
        <MuiThemeProvider theme={footerTheme}>
            <AppBar id="fuse-footer" className="relative z-10" color="default">
                <Toolbar className="px-16 py-0 flex items-center min-h-32">
                    <div className="flex items-center">
                        <div className="flex text-center items-center">
                            {settings !== undefined && settings !== null && settings.sistemas !== undefined && settings.sistemas !== null && settings.sistemas[xappRouteParams.empresa] !== undefined &&
                                <Avatar
                                    alt={"Avatar" + xappRouteParams.empresa}
                                >
                                    {Helpers.getAcronimo(settings.sistemas[xappRouteParams.empresa].nomesocial)}
                                </Avatar>
                            }
                        </div>
                        <XAPPButton
                            tooltip={{ "title": "Home", "placement": "top" }}
                            type="Icon"
                            className=""
                            onClick={() => history.push('/home')}
                            icon={"home"}
                        />
                        <XAPPButton
                            tooltip={{ "title": "Atualizar", "placement": "top" }}
                            type="Icon"
                            className=""
                            onClick={() => {
                                sessionStorage.clear();
                                serviceWorker.unregister();
                                document.location.reload(true);
                            }}
                            icon={"refresh"}
                        />
                        {/* <XAPPTour
                            settings={settings}      VER MARIO
                        />
                        <XAPPButton
                            type="Icon"
                            className=""
                            onClick={() => serviceWorker.showNotification({titulo: "teste...123"})}
                            icon={"add"}
                        /> */}
                    </div>
                    <div className="flex-1" />
                    <div className="flex">
                        <ReportBug
                            local={document.location.pathname}
                        />
                        <LockPage />
                        <ViewUID />
                        <TermoUso type="button" />
                        <UpdateVersion />

                        {/* <Tooltip title="XAPP Sistemas LTDA" placement="top">
                            <IconButton className="min-w-32 min-h-32" component="a" href="https://www.xapp.com.br" target="_blank" rel="noreferrer noopener">
                                <img
                                    src="assets/images/logos/xapp.ico"
                                    alt="xapp"
                                    width="16"
                                />
                            </IconButton>
                        </Tooltip> */}
                    </div>
                </Toolbar>
            </AppBar>
        </MuiThemeProvider>
    );
};



function mapStateToProps({ fuse, auth }) {
    return {
        footerTheme: fuse.settings.footerTheme,
        settings: auth.user.data.settings
    }
}

export default connect(mapStateToProps)(FooterLayout1);

